export default function registerRightClickHandler(viewer :any){
    
    // Handle right click event on the image viewer
    viewer.addHandler('canvas-nonprimary-press', function (event: any) {
        if (event.button === 2) { // Check if the right mouse button was pressed
            event.preventDefaultAction = true; // Prevent the default context menu
            viewer.viewport.zoomBy(0.5); // Zoom out; adjust the factor as needed
            viewer.viewport.applyConstraints();
        }
    });
    
    // Prevent the default context menu from opening on right click
    viewer.canvas.addEventListener('contextmenu', function (event: any) {
        event.preventDefault();
    });
}